import getHexColorFromNamed from './getHexColorFromNamed.js'

export default getHexColorFromNamed
